/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export const SessionPlanDefaultItemIdEnum = Object.freeze({
	TLSW_AIMS: "TLSW_AIMS",
	TLSW_HOW: "TLSW_HOW",
	TLSW_TOOLS: "TLSW_TOOLS",
	TLSW_MATERIALS: "TLSW_MATERIALS",
	TLSW_RISK: "TLSW_RISK",
	TLSW_OUTCOME: "TLSW_OUTCOME",
	TLSW_EVALUATION: "TLSW_EVALUATION",
	TLSW_REFLECTIONS: "TLSW_REFLECTIONS",
	TLSW_BOOK_CONTENT: "TLSW_BOOK_CONTENT",

	BT_LEAVES: "BT_LEAVES",
	BT_ROOTS: "BT_ROOTS",
	BT_DISCUSSION: "BT_DISCUSSION",
	BT_TOOLS: "BT_TOOLS",
	BT_MATERIALS: "BT_MATERIALS",
})
